//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    id: {
      type: String,
      default: 'accordion',
      required: true,
    },
    items: {
      type: Array,
      default() {},
    },
    alternativeIcon: {
      type: Boolean,
      default: false,
    },
  },
}
